import _ from 'lodash'

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    operationList: {
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showProblemSolvingFit: {
      type: Boolean,
      default: false
    },
    showAssessmentFit: {
      type: Boolean,
      default: false
    },
    showAiInterviewFit: {
      type: Boolean,
      default: false
    },
    showChannel: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    showQuicklyChangeStatus: {
      type: Boolean,
      required: false
    },
    showResumeFit: {
      type: Boolean,
      default: false
    },
    showAIRecommendedFit: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    showAIInterviewScore: {
      default: false
    },
    showInterviewScore: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDuplicateCandidatePermission () {
      return this.hasAnyPermission('PREMIUM_DUPLICATE_CANDIDATE')
    },
    hasAssessmentPermission () {
      return this.hasAnyPermission('PREMIUM_ASSESSMENTS')
    },
    listEl () {
      throw Error('no implement')
    }
  },
  data () {
    return {
      atBottom: false,
      emitScrollBottom: null
    }
  },
  created () {
    this.emitScrollBottom = _.debounce(() => {
      this.$emit('scrollBottom')
    }, 200)
  },
  mounted () {
    this.addScrollEvent()
  },
  methods: {
    emitCandidateStatusClickEvent (rowData) {
      this.$emit('candidateStatusClick', rowData)
    },
    emitOpenDetailEvent (rowData) {
      this.$emit('openDetail', rowData)
    },
    emitSelectedChangeEvent (selected) {
      this.$emit('selectedChange', selected)
    },
    addScrollEvent () {
      const el = this.listEl
      el.addEventListener('scroll', () => {
        const distance = el.scrollHeight - el.scrollTop - el.clientHeight - 10
        if (distance <= 50) {
          if (!this.atBottom) {
            this.emitScrollBottom()
          }
          this.atBottom = true
        } else {
          this.atBottom = false
        }
      })
    },
    scrollToTop () {
      const el = this.listEl
      el.scrollTo({
        top: 0
      })
    }
  }
}
